import { createAsyncThunk } from '@reduxjs/toolkit';

import callApi from '../../../service/callApi';
import sendRequest from '../../../service/sendRequest';
import { enqueueSnackbar } from '../../notifier/notifierActions';
import { PROJECT_TYPES } from '../../../constants';

export const SEARCH_ACTIV8_PROJECTS = 'activ8Settings/SEARCH_ACTIV8_PROJECTS';
export const SEARCH_DELETED_ACTIV8_CONTENT = 'activ8Settings/SEARCH_DELETED_ACTIV8_CONTENT';
export const RESTORE_ACTIV8_CONTENT = 'activ8Settings/RESTORE_ACTIV8_CONTENT';

export const searchActiv8Projects = createAsyncThunk(SEARCH_ACTIV8_PROJECTS, async () => {
  const response = await sendRequest(() =>
    callApi.post(`/api/project/search?page=1&size=1000&sort=-createdOn`, {
      projectType: PROJECT_TYPES.ACTIV8,
    }),
  );

  return response.data.content ?? [];
});

export const searchDeletedActiv8Content = createAsyncThunk(
  SEARCH_DELETED_ACTIV8_CONTENT,
  async (_, { getState, rejectWithValue }) => {
    const { selectedProjectId, tableSettings } = getState().activ8Settings;
    const { page, size, sort } = tableSettings;

    if (!selectedProjectId) {
      return rejectWithValue(null);
    }

    const response = await sendRequest(() =>
      callApi.get(
        `/api/activ8/media/search/deleted?projectId=${selectedProjectId}&page=${page + 1}&size=${size}&sort=${sort}`,
      ),
    );

    return {
      content: response.data.content ?? [],
      totalElements: response.data.totalElements ?? 0,
    };
  },
);

export const restoreActiv8Content = createAsyncThunk(
  RESTORE_ACTIV8_CONTENT,
  async ({ contentId }, { dispatch, getState, rejectWithValue }) => {
    await sendRequest(() => callApi.post(`/api/activ8/media/restore?contentId=${contentId}`), {
      onError: () => {
        dispatch(
          enqueueSnackbar({
            message: 'couldntRestoreContent',
            options: { variant: 'error' },
          }),
        );
        return rejectWithValue(null);
      },
    });

    dispatch(
      enqueueSnackbar({
        message: 'contentHasBeenRestored',
        options: { variant: 'success' },
      }),
    );

    const { content, tableSettings } = getState().activ8Settings;
    const remainingOnPage = content.filter((item) => item.bucketId !== contentId).length;
    const shouldGoToPreviousPage = remainingOnPage === 0 && tableSettings.page > 0;

    if (!shouldGoToPreviousPage) {
      await dispatch(searchDeletedActiv8Content());
    }

    return { contentId, shouldGoToPreviousPage };
  },
);
